import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants'
import {
	RetentionAnalyticsService,
	TTFDDistributionQuery,
	TTFDDistributionResponse,
} from '../services'

export const useQueryGetTTFDDistribution = (
	query?: TTFDDistributionQuery,
	enabled = true,
) => {
	return useQuery<TTFDDistributionResponse>({
		queryKey: QUERY_KEYS.RETENTION_ANALYTICS.TTFD(query),
		queryFn: () => RetentionAnalyticsService.getTTFDDistribution(query),
		enabled,
	})
}
